var Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.PaymentMethodValidation = (function () {
  function errorNotice() { return $('#form-error-notice'); }
  function paymentError() { return $('.payment-error'); }

  function form() {
    return $('form.product');
  }

  function paymentCheckboxes() {
    return form().find(':checkbox[name=\'product[accepted_payment_methods][]\']');
  }

  function shopSupportsDirectCheckout() {
    return $('[data-shop-supports-direct-checkout]').length > 0;
  }

  function showPaymentErrorIfNeeded() {
    if (errorOnPaymentMethods()) {
      errorNotice().fadeIn();
      paymentError().fadeIn();
      return false;
    } else {
      paymentError().fadeOut();
      return true;
    }
  }

  function errorOnPaymentMethods() {
    if (paymentCheckboxes().length === 0 || shopSupportsDirectCheckout()) {
      return false;
    } else {
      return !paymentCheckboxes().is(':checked');
    }
  }

  function handleValidateFormOfPayment() {
    paymentCheckboxes().change(function () {
      showPaymentErrorIfNeeded();
    });

    form().submit(function (e) {
      return showPaymentErrorIfNeeded();
    });
  }

  function init() {
    handleValidateFormOfPayment();
  }

  return {
    init: init,
    showPaymentErrorIfNeeded: showPaymentErrorIfNeeded
  };
})();

$(function () {
  Reverb.Listing.PaymentMethodValidation.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/payment_method_validation.js